// extracted by mini-css-extract-plugin
module.exports = {"charitiesHeading":"CauseMiniSection_charitiesHeading__Naigs"};